import React from "react";

const VisionIcon = ({
  className = "",
  viewBox = "0 0 36 36",
  fill = "currentColor",
  stroke = "currentColor",
  strokeWidth = "2",
  ...props
}) => (
  <svg
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M18 4.5C10.268 4.5 4 10.768 4 18.5C4 26.232 10.268 32.5 18 32.5C25.732 32.5 32 26.232 32 18.5C32 10.768 25.732 4.5 18 4.5ZM18 7.5C24.065 7.5 29 12.435 29 18.5C29 24.565 24.065 29.5 18 29.5C11.935 29.5 7 24.565 7 18.5C7 12.435 11.935 7.5 18 7.5ZM18 11C16.343 11 15 12.343 15 14C15 15.657 16.343 17 18 17C19.657 17 21 15.657 21 14C21 12.343 19.657 11 18 11ZM18 19.5C14.686 19.5 12 22.186 12 25.5H24C24 22.186 21.314 19.5 18 19.5Z"
      fill={fill}
    />
  </svg>
);

export default VisionIcon;
